import { Button, IconButton } from "@design";
import { Plus, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { withForm } from "@/components/form/form";
import { Text } from "@/components/Text";
import { toValues } from "./connectorValues";

const emptyRow = () => ({ key: crypto.randomUUID(), name: "", value: "" });

/** Fixed, non-secret headers sent on every call, e.g. X-MCP-Toolsets (MHS-871). */
export const HeadersEditor = withForm({
  defaultValues: toValues(),
  render: function HeadersEditorRender({ form }) {
    const { t } = useTranslation("connectors");
    return (
      <fieldset className="flex flex-col gap-3">
        <legend className="mb-1">
          <Text as="span" variant="body">
            {t("form.headers.title")}
          </Text>
        </legend>
        <Text variant="caption" tone="tertiary">
          {t("form.headers.hint")}
        </Text>
        <form.Field name="headers" mode="array">
          {(list) => (
            <>
              {list.state.value.map((row, i) => (
                <div key={row.key} className="flex items-end gap-2">
                  <div className="grid flex-1 grid-cols-1 gap-3 md:grid-cols-2">
                    <form.AppField name={`headers[${i}].name`}>
                      {(field) => <field.TextField label={t("form.headers.name")} required />}
                    </form.AppField>
                    <form.AppField name={`headers[${i}].value`}>
                      {(field) => <field.TextField label={t("form.headers.value")} />}
                    </form.AppField>
                  </div>
                  <IconButton
                    icon={<Trash2 />}
                    variant="ghost"
                    size="sm"
                    aria-label={t("form.headers.remove", { name: row.name || String(i + 1) })}
                    onClick={() => list.removeValue(i)}
                  />
                </div>
              ))}
              <div>
                <Button
                  variant="secondary"
                  size="sm"
                  leadingIcon={<Plus size={14} />}
                  onClick={() => list.pushValue(emptyRow())}
                >
                  {t("form.headers.add")}
                </Button>
              </div>
            </>
          )}
        </form.Field>
      </fieldset>
    );
  },
});
